export default __webpack_public_path__ + "static/media/form-img-2.71a04247.png";